import React from 'react';
import Game from './components/Game';
import 'bootstrap/dist/css/bootstrap.min.css';


function App() {

  return (
    <Game/>
  );
}

export default App;
